import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { KYMW1300GetOrderNumQuotaDataModel } from '../vo/kymw1300-get-order-num-quota-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　注文コード割当情報取得するサービス
 *
 * @export GetOrderNumQuotaDataService
 * @class GetOrderNumQuotaDataService
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class GetOrderNumQuotaDataService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetOrderNumQuotaDataService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW1300GetOrderNumQuotaDataModel}
   * @memberof GetOrderNumQuotaDataService
   */
  private vo: KYMW1300GetOrderNumQuotaDataModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetOrderNumQuotaDataService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderNumQuotaDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        OrderCodeFrom: this.vo.orderCodeFrom,
        OrderCodeTo: this.vo.orderCodeTo,
        MediumType: this.vo.mediumType,
        ComboType: this.vo.comboType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetOrderNumQuotaDataService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model>model;
    this.vo = <KYMW1300GetOrderNumQuotaDataModel>vo;
    this.successFunc = successFunc;
    this.send('getOrderNumQuotaData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOrderNumQuotaDataService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
